export default "__VITE_ASSET__DxsENF$r__"